import { render, staticRenderFns } from "./accepting_draft_order_form.vue?vue&type=template&id=5f0d2e60&scoped=true&lang=pug&"
import script from "./accepting_draft_order_form.vue?vue&type=script&lang=js&"
export * from "./accepting_draft_order_form.vue?vue&type=script&lang=js&"
import style0 from "./accepting_draft_order_form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./accepting_draft_order_form.vue?vue&type=style&index=1&id=5f0d2e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d2e60",
  null
  
)

export default component.exports